export default "__VITE_PUBLIC_ASSET__d2d869e1__"